



function priceRangeSlider() {


    if( $(".prcrng-tpl-m7").length ){

        // slider 1
        var selectSlider1 = '.js-input-with-keypress-1';
        var rangSliderMin1 = $(selectSlider1).attr("data-rangemin");
        var rangSliderMax1 = $(selectSlider1).attr("data-rangemax");
        var startValueSlider1 = $(selectSlider1).attr("value");
        var clickPipsSlider1 = document.querySelector(".slider-skip-1");
        var stepSlider1 = $(selectSlider1).attr("data-step");



        noUiSlider.create(clickPipsSlider1, {
            connect: [true, false],
            range: {
                min: [parseInt(rangSliderMin1)],
                // max: 100
                max: [parseInt(rangSliderMax1)]
            },
            // step: 1,
            step: parseInt(stepSlider1),
            start: [startValueSlider1],
            pips: {mode: 'count', values: 2},
            format: wNumb({
                decimals: 0,
                thousand: ',',
            })
        });


        var pips = clickPipsSlider1.querySelectorAll('.noUi-value');

        function clickOnPip1() {
            var value = Number(this.getAttribute('data-value'));
            clickPipsSlider1.noUiSlider.set(value);
        }

        for (var i = 0; i < pips.length; i++) {

            // For this example. Do this in CSS!
            pips[i].style.cursor = 'pointer';
            pips[i].addEventListener('click', clickOnPip1);
        }

        var inputFormat1 = document.querySelector(selectSlider1);

        clickPipsSlider1.noUiSlider.on('update', function( values, handle, unencoded ) {
          inputFormat1.value = values[handle];
        });

        inputFormat1.addEventListener('change', function(){
          clickPipsSlider1.noUiSlider.set(this.value);
        });




        // slider 2
        var selectSlider2 = '.js-input-with-keypress-2';
        var rangSliderMin2 = $(selectSlider2).attr("data-rangemin");
        var rangSliderMax2 = $(selectSlider2).attr("data-rangemax");
        var startValueSlider2 = $(selectSlider2).attr("value");
        var clickPipsSlider2 = document.querySelector(".slider-skip-2");
        var stepSlider2 = $(selectSlider2).attr("data-step");



        noUiSlider.create(clickPipsSlider2, {
            connect: [true, false],
            range: {
                min: [parseInt(rangSliderMin2)],
                // max: 100
                max: [parseInt(rangSliderMax2)]
            },
            start: [startValueSlider2],
            // step: 1,
            step: parseInt(stepSlider2),
            pips: {mode: 'count', values: 2},

            format: wNumb({
                decimals: 0,
                thousand: ',',
            })
        });


        var pips = clickPipsSlider2.querySelectorAll('.noUi-value');

        function clickOnPip2() {
            var value = Number(this.getAttribute('data-value'));
            clickPipsSlider2.noUiSlider.set(value);
        }

        for (var i = 0; i < pips.length; i++) {

            // For this example. Do this in CSS!
            pips[i].style.cursor = 'pointer';
            pips[i].addEventListener('click', clickOnPip2);
        }

        var inputFormat2 = document.querySelector(selectSlider2);

        clickPipsSlider2.noUiSlider.on('update', function( values, handle, unencoded ) {
          inputFormat2.value = values[handle];
        });

        inputFormat2.addEventListener('change', function(){
          clickPipsSlider2.noUiSlider.set(this.value);
        });
    }
};





export {priceRangeSlider}
